import { formatDate } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CourseEnrollment } from 'src/app/models/course-enrollment';
import { Enrollment } from 'src/app/models/enrollment';
import { StudentEnrollment } from 'src/app/models/student-enrollment';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnrollService {
  private readonly serviceName = 'enroll';
  private readonly headers = { headers: new HttpHeaders({ "Authorization": environment.apiKeyInternal })};  

  constructor(private http: HttpClient) {}

  public get(cid: number, date: Date): Observable<Enrollment> {
    let params = new HttpParams()
      .set('cid', cid)
      // Don't ask for the locale, it returns string in desired format. 
      .set('date', date.toLocaleDateString('sv-SE')); 
    return this.http.get<Enrollment>(
      `${environment.apiUrl}${this.serviceName}/get.php`,
      { params: params, headers: this.headers.headers }
    );
  }

  public set(
    sid: number,
    enrollments: StudentEnrollment[]
  ): Observable<boolean> {
    const payload = `sid=${sid}&enrollments=${JSON.stringify(enrollments)}`;

    return this.http.post<boolean>(
      `${environment.apiUrl}${this.serviceName}/set.php`,
      payload,
      this.headers
    );
  }

  public del(cid: number, sid: number, date: Date): Observable<boolean> {
    // Don't ask for the locale, it returns string in desired format. 
    const payload = `cid=${cid}&sid=${sid}&date=${date.toLocaleDateString('sv-SE')}`;

    return this.http.post<boolean>(
      `${environment.apiUrl}${this.serviceName}/del.php`,
      payload,
      this.headers
    );
  }

  public add(
      sid: number,
      cid: number,
      begin: string,
      end: string
  ): Observable<boolean> {
    const payload =
      `sid=${sid}` +
      `&cid=${cid}` +
      `&begin=${encodeURIComponent(begin)}` +
      `&end=${encodeURIComponent(end)}`;

    return this.http.post<boolean>(
      `${environment.apiUrl}${this.serviceName}/add.php`,
      payload,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': environment.apiKeyInternal
        })
      }
    );
  }
}
